export enum SummitWizardStepLayout {
  Custom = 0,
  Buttons = 1,
  Field = 2, //might combine with buttons
  File = 3
}
